import Sidebar from "./Sidebar";
import { Link, useParams } from "react-router-dom";
import ExportSidebar from "./ProSideBar";
import { PageHeader } from "./AuxiliaryFunctions";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import UserDataService from './services/user.serviceaux.js';
import { Button, Container, OverlayTrigger, Row, Table } from "react-bootstrap";
import { CiCircleCheck, CiCircleMinus } from "react-icons/ci";
import { AiFillCheckCircle } from "react-icons/ai";
import { MdCancel } from "react-icons/md";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { RiFileExcel2Fill } from "react-icons/ri";


const ListaCompleta = () => {

    const { user: currentUser } = useSelector((state) => state.auth);	
    let params = useParams();
    let compid = params.compid;
    const [lista, setLista] = useState();

    const exportToExcel = () => {
        let listaExportada = [...lista];
        listaExportada.forEach(object => {
            delete object['userid'];
            delete object['arean1Id'];
            delete object['arean2Id'];
            delete object['organigramaareasId'];
            delete object['childid'];
            delete object['uid'];
            delete object['orgid'];
            delete object['compid'];
            object['Area N1 con más experiencia'] = object['arean1experiencia']
            delete object['arean1experiencia'];
            object['Area N2 con más experiencia'] = object['arean2experiencia']
            delete object['arean2experiencia'];            
            delete object['childcategory'];        
            object['Area asignada'] = object['nombrearea']
            delete object['nombrearea'];                                
            object['Confirmación activa'] = object['confirmacion_activa']
            delete object['confirmacion_activa'];                        
            object['Comentarios del juez'] = object['comentariosdeljuez']
            delete object['comentariosdeljuez'];                                            
            object['Nombre competencia'] = object['nombrecompetencia']
            delete object['nombrecompetencia'];                                                        
        });
        // Convert the JSON data array to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(lista);
        // Create a new workbook
        const workbook = XLSX.utils.book_new();
        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        // Write the workbook to a buffer
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        // Create a Blob object and save the file
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        saveAs(blob, 'Lista completas' + '.xlsx'); // Use file-saver to download
    };

    useEffect(() => {
        UserDataService.getListaCompleta(compid,0,"id","ASC")
        .then(resp => {
            console.log(resp.data);
            setLista(resp.data);
        })
        .catch(err => {
            console.log(err);
        });
    },[]);

    return (
        <>
        <Sidebar />
        <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
            <ExportSidebar roles={currentUser.roles}/>        
            <div style={{display:'block',width:'100%'}}>
                <PageHeader />        
                <div className="main-frame-page">
                    <h5 style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>{"Lista completa de jueces"}</h5>
                    <button className="btn btn-secondary" onClick={exportToExcel}>
                        <RiFileExcel2Fill />
                    </button>                                        
                    < hr/>
                    <Table style={{verticalAlign:"baseline"}} size="sm">
                        <TableHeader/>
                        <TableBody listOf={lista} />
                    </Table>
                </div>
            </div>
        </div>
        </>  
    );
};

const TableHeader = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);	
  return (

    <thead>
      <tr>
        <th style={{width:'17%'}}>Juez</th>
        <th style={{width:'5%'}}>Disponibilidad?</th>
        <th style={{width:'5%'}}>Asignado?</th>
        <th style={{width:'30%'}}>Comentarios del juez</th>        
        <th style={{width:'20%'}}>Area con mayor experiencia</th>
        <th>Area asignada</th>
      </tr>
    </thead>
  )
}


const TableBody = (props) => {  
    const { user: currentUser } = useSelector((state) => state.auth);	

    if (props.listOf) {    
        const rows = props.listOf.map((row, index) => {         
        return (      
            <>
            <tr key={index}>        
            <td className='d-none d-sm-table-cell'>
                {
                    (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim() + " " +
                    (row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                }
            </td>
            <td>
                {row.confirmacion_activa==1?<AiFillCheckCircle size={25} color="green"/>:<MdCancel size={26} color="red"/>}
            </td>     
            <td>
                {row.compid?<AiFillCheckCircle size={25} color="green"/>:<MdCancel size={26} color="red"/>}
            </td>
            <td>
                {row.comentariosdeljuez}    
            </td>                   
            <td>
                {((row.arean1experiencia || "") + " - " + (row.arean2experiencia || "")).trim()}
            </td>
            <td>  
                {row.nombrearea}
            </td>
            </tr>
            </>
        )
        })
        return (
        <tbody>
            {rows}
        </tbody>
        )  
    }
    else {
        return null;
    }
}




export default ListaCompleta;